<template>
  <div>
    <div v-bind:key="'print-multi-image'+d.id" v-for="d in selected">
      <qr-image :item="d"/>
    </div>
    <QrImageDownloaderNew
      @hasDownloaded="hasDownloaded()"
      :dataList="selected"
      :enableDownload="enableImagesDownload"
      @keydown.esc="vm_multipleQrDialog(false)"
    />
    <v-dialog
      persistent
      @keydown.esc="vm_multipleQrDialog(false)"
      :value="vg_multipleQrDialog"
      max-width="60vw"
    >
      <qr-to-html
        ref="multiHtml2Pdf"
        @hasDownloaded="hasDownloaded()"
        :dataList="selected"
        :fileName="fileName"
        @keydown.esc="vm_multipleQrDialog(false)"
      />
      <v-card>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="vg_items"
          :loading="isfetching"
          :single-select="false"
          item-key="slug"
          :items-per-page="vg_items.length"
          show-select
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.is_vacant="{ item }">
            <v-simple-checkbox
              :value="item.is_vacant"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
        <v-card-actions class="justify-center">
          <v-btn
            depressed
            color="primary"
            @click="downloadImages()"
            :loading="isLoading"
            :disabled="isLoading"
          >
            Download Images
          </v-btn>
          <v-btn
            depressed
            color="primary"
            @click="downloadPDF()"
            :loading="isLoading"
            :disabled="isLoading"
          >
            <v-icon left>
              mdi-arrow-down-circle
            </v-icon>
            Download PDFs
          </v-btn>
          <v-btn depressed color="primary" @click="vm_multipleQrDialog(false)">
            <v-icon left>
              mdi-check
            </v-icon>
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import QrToHtml from '@/components/custom-components/QrToHtml'
import QrImageDownloader from '@/components/custom-components/QrImageDownloader.vue'
import QrImage from '@/components/custom-components/QrImage.vue'
import * as htmlToImage from 'html-to-image'
import { changeDpiDataUrl } from 'changedpi'

export default {
  name: 'MultipleQRDialog',
  components: {
    QrToHtml,
    QrImageDownloader,
    QrImage
  },
  data() {
    return {
      selected: [],
      headers: [
        { text: 'Name', value: 'label', sortable: true, width: 200 },
        { text: 'Is Vacant', value: 'is_vacant', sortable: false, width: 200 },
        { text: 'Slug', value: 'slug', sortable: false, width: 200 },
        { text: 'Number', value: 'table_number', sortable: false, width: 200 }
      ],
      isLoading: false,
      isfetching: false,
      enableImagesDownload: false
    }
  },
  computed: {
    ...mapGetters({
      vg_items: 'table/getRows',
      vg_multipleQrDialog: 'table/isMultipleQrDialog'
    }),
    fileName() {
      return `multiple-table-${new Date().toISOString().slice(0, 10)}.pdf`
    }
  },
  watch: {
    vg_multipleQrDialog(val) {
      if (val === true) {
        this.selected = []
      }
    }
  },
  methods: {
    hasDownloaded() {
      this.isLoading = false
      this.enableImagesDownload = false
    },
    async downloadImages() {
      this.loading = true
      this.enableImagesDownload = true
      for (let i = 0; i < this.selected.length; i++) {
        let name = this.selected[i].label ? this.selected[i].label + '_' + this.selected[i].table_number + '.png' : 'image.png'
        await htmlToImage
          .toPng(document.getElementById('image' + this.selected[i].id))
          .then(function(dataUrl) {
            const downloadLink = document.createElement('a')
            downloadLink.href = changeDpiDataUrl(dataUrl, 300)
            downloadLink.download = name
            downloadLink.click()
          })
          .catch(err => {
            console.log(err)
          })
      }
      this.hasDownloaded()
    },
    downloadPDF() {
      if (this.selected.length) {
        this.isLoading = true
        this.$refs.multiHtml2Pdf.generatePdf()
      } else {
        this.snackbar({
          text: 'please select rows.',
          open: true,
          color: 'error'
        })
      }
    },
    ...mapMutations({
      vm_multipleQrDialog: 'table/SET_DIALOG_MULTIPLE_QR_CREATE'
    })
  }
}
</script>
